import { NOBU_THEME_PATH } from "../constants";

export const themeImage = (imageFileNameOrPath: string): string => {
    return NOBU_THEME_PATH + '/images/' + imageFileNameOrPath;
};
